import { IGroupSpaceResource } from "../../group-spaces";
import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalValue, mapRelationalValue } from "../../utils/filters";

export type IGroupSpaceDeleteMutationParameters = {
    groupSpace?: RelationalValue<IGroupSpaceResource>;
};

export type IGroupSpaceDeleteMutationResult = void;

export const groupSpaceDeleteMutation: IApiMutationFunction<IGroupSpaceDeleteMutationParameters> = ({ groupSpace }) => {
    return {
        method: "DELETE",
        url: `/group_spaces/${mapRelationalValue(groupSpace)}`,
    };
};

export const useGroupSpaceDeleteMutation = createApiMutationHook<
    IGroupSpaceDeleteMutationParameters,
    IGroupSpaceDeleteMutationResult
>(groupSpaceDeleteMutation);
